<template>
  <auth-layout>
    <oxd-text class="gsl-hrm-login-title" tag="h5">
      {{ $t('auth.multifactorauthlang') }}
    </oxd-text>
    <div class="gsl-hrm-login-form">
      <div class="gsl-hrm-login-error">
        <oxd-alert
          :show="error !== null"
          :message="error?.message || ''"
          type="error"
        ></oxd-alert>
      </div>
      <oxd-form
        ref="multiFactorKeySubmitForm"
        method="post"
        :action="submitUrl"
        @submit-valid="onSubmit"
      >
        <input name="_token" :value="token" type="hidden" />
        <div class="gsl-hrm-align-center">
          <div v-if="google2faQrCode">
            <img
              v-if="base64QrCode"
              :src="`data:image/svg+xml;base64,${base64QrCode}`"
              alt="2FA QR Code"
            />
          </div>
          <p>
            Scan the QR Code with any Authenticator App from the Play Store or
            AppStore
          </p>
          or Copy and Paste the Setup Key from below.
          <div class="login-clipboard">
            <input
              :value="google2faSecretKey"
              class="copy-input"
              name="google2faSecretKey"
              readonly
            />
            <button class="copy-btn" @click.prevent="copyToClipboard">
              <img :src="copyIconPng" />
            </button>
          </div>

          <p>
            Press Coutinue after Setting Up (Once you press continue
            authentication can't be Altered)
          </p>
        </div>

        <oxd-form-actions class="gsl-hrm-login-action">
          <oxd-button
            class="gsl-hrm-login-button"
            display-type="main"
            :label="$t('general.verify')"
            type="submit"
          />
        </oxd-form-actions>
        <!-- <oxd-form-row>
          <oxd-input-field
            :model-value=""
            :label="$t('auth.username')"
            readonly
            name="google2faSecretKey"
            label-icon="person"
          />
        </oxd-form-row> -->
      </oxd-form>
      <br />
    </div>
    <div class="gsl-hrm-login-footer">
      <slot name="footer"></slot>
    </div>
  </auth-layout>
</template>
<script>
import {urlFor} from '@ohrm/core/util/helper/url';
import {reloadPage} from '@ohrm/core/util/helper/navigation';
import AuthLayout from '../components/AuthLayout';
import {OxdAlert} from '@ohrm/oxd';
export default {
  name: 'GenerateMultiFactor',
  components: {
    'oxd-alert': OxdAlert,
    'auth-layout': AuthLayout,
  },
  props: {
    token: {
      type: String,
      required: true,
    },
    error: {
      type: Object,
      default: () => null,
    },
    showSocialMedia: {
      type: Boolean,
      default: true,
    },
    google2faQrCode: {
      type: String,
      default: 'Invalid',
    },
    google2faSecretKey: {
      type: String,
      default: null,
    },
    copyIconPng: {
      type: String,
      default: 'NO',
    },
  },
  data() {
    return {
      authenticationPin: '',
      submitted: false,
    };
  },

  computed: {
    submitUrl() {
      return urlFor('/auth/subMultiFactor');
    },
    base64QrCode() {
      if (typeof window !== 'undefined' && window.btoa) {
        return btoa(this.google2faQrCode);
      }
      return '';
    },
  },

  beforeMount() {
    setTimeout(() => {
      reloadPage();
    }, 1200000); // 20 * 60 * 1000 (20 minutes);
  },
  methods: {
    onSubmit() {
      if (!this.submitted) {
        this.submitted = true;
        this.$refs.multiFactorKeySubmitForm.$el.submit();
      }
    },
    copyToClipboard() {
      const inputField = this.$refs.copyInput;
      inputField.select();
      document.execCommand('copy');
    },
  },
};
</script>
<style src="./login.scss" lang="scss" scoped></style>
